module.exports = __webpack_public_path__ + "img/Stylized Sword-Gold.bff07123.png";